import { Button, List, Tooltip } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { EyeOutlined } from '@ant-design/icons'
import { useAppSelector } from 'src/app/hooks'
import { offsetByExcelSelector } from 'src/features'
import { CustomModal, CustomText } from 'src/components'
import styles from './PreviewExtraDataColumn.module.scss'
import { getOptionalFieldWithExcelData } from 'src/core/helpers'

const PreviewExtraDataColumn: React.FC<{ excelData: object }> = ({ excelData }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { offsetOptionalKeys } = useAppSelector(offsetByExcelSelector)
  const extraDataValues = getOptionalFieldWithExcelData(offsetOptionalKeys, excelData)

  const tooltipValues = {
    EMPTY: { label: t('There is no extra data'), color: 'green' },
    DATA: { label: t('Check extra data'), color: 'blue' },
  }[extraDataValues?.length === 0 ? 'EMPTY' : 'DATA']

  return <div className={styles.content}>
    <Tooltip title={tooltipValues.label} color={tooltipValues.color}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        disabled={extraDataValues?.length === 0}
        className={`radius-100`}
        onClick={() => setIsModalVisible(true)}
        icon={<EyeOutlined />}
      />
    </Tooltip>

    <CustomModal
      width={650}
      footer={null}
      open={isModalVisible}
      title={t('Offset Extra data')}
      onCancel={() => setIsModalVisible(false)}
    >
      <List dataSource={extraDataValues}
        renderItem={item => (
          <List.Item>
            <React.Fragment>
              <CustomText label={t(`developers.OffSet.Fields.${item.field}`)} mark/>
              <CustomText label={item.value} type={null} />
            </React.Fragment>
          </List.Item>
        )}
      />
    </CustomModal>
  </div>
}

export default PreviewExtraDataColumn
